import { render, staticRenderFns } from "./App.vue?vue&type=template&id=01b52a56&scoped=true&lang=pug&"
import script from "./App.vue?vue&type=script&lang=coffee&"
export * from "./App.vue?vue&type=script&lang=coffee&"
import style0 from "./App.vue?vue&type=style&index=0&id=01b52a56&lang=sass&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b52a56",
  null
  
)

export default component.exports